<template>
  <div
    class="text-image-block"
    :class="{
      '--image-left': props.content?.imageOnTheLeft,
      '--larger': props.content?.fullwidth,
      'row-300-40': !props.content?.fullwidth,
      'row-160-230-40': props.content?.fullwidth,
    }"
  >
    <div class="text-image-block__wrap">
      <!-- Heading principale (mobile) -->
      <div
        v-if="props.content?.textHeading"
        class="text-image-block__text__heading hide-for-large"
        v-html="props.content?.textHeading"
      />

      <!-- Blocco di testo (a sx di default) -->
      <div class="text-image-block__text">
        <!-- Heading principale (desktop) -->
        <div
          v-if="props.content?.textHeading"
          class="text-image-block__text__heading show-for-large"
          v-html="props.content?.textHeading"
        />
        
        <!-- Testo principale obbligatorio -->
        <div
          v-if="props.content?.text"
          class="text-image-block__text__main"
          v-html="props.content?.text"
        />

        <!-- Blocco CTA opzionale -->
        <div
          v-if="props.content?.textLink?.label && props.content?.textLink?.linkUrl"
          class="text-image-block__text__cta"
        >
          <WidgetArrowLink :label="props.content?.textLink?.label" :link="props.content?.textLink?.linkUrl" />
        </div>
      </div>

      <!-- Blocco media (a dx di default) -->
      <div class="text-image-block__media" :class="{'--fixed-ratio': props.content?.videoLink}">
        <WidgetVideo
          v-if="props.content?.videoLink"
          class="is-cover"
          :videoUrl="props.content?.videoLink"
          :loop="true"
          :forcePlay="true"
          :autoplay="true"
          :muted="true"
          :preload="'auto'"
          :playInViewport="true"
        />
        <WidgetPicture
          v-else-if="props.content?.image.responsiveImage"
          class="is-cover"
          :image="{
            custom: props.content.image.responsiveImage,
          }"
          :alt="
            props.content.image.responsiveImage?.alt
              ? props.content.image.responsiveImage.alt
              : props.content.text
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextImageBlock',
}
</script>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>
